import React, { useEffect, useState, createContext, useContext } from 'react';

const ConfigContext = createContext<any | undefined>(undefined);

const fetchConfig = (name: string, url: string): Promise<[name: string, config: any]> =>
  fetch(url)
    .then((response) => response.json())
    .then((config) => [name, config]);

interface ConfigProviderProps {
  items: Array<{
    name: string;
    url: string;
  }>;
}
export const ConfigProvider: React.FC<ConfigProviderProps> = ({ items, children }: any) => {
  const [config, setConfig] = useState<any | null>(null);

  useEffect(() => {
    Promise.all(items.map(({ name, url }: ConfigProviderProps['items'][0]) => fetchConfig(name, url)))
      .then((results: any[]) => {
        setConfig(Object.fromEntries(results));
      })
      .catch((error) => {
        setConfig(error);
      });
  }, [items]);

  return <ConfigContext.Provider value={config}>{children}</ConfigContext.Provider>;
};

export const useConfig = (): any => {
  const config = useContext(ConfigContext);
  if (config instanceof Error) {
    config.message = `Error while fetching the application config: ${config.message}`;
    throw config;
  }
  if (config === undefined) {
    throw Error('useConfig must be used within a ConfigProvider tag');
  }
  return config;
};
